<div class="work-interval" *ngIf="workInterval"></div>
